import type { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { ChevronLeftIcon } from '@/design-system/icons'

interface Props {
  title?: string
  back?: boolean | (() => void)
  action?: ReactNode
  children?: ReactNode
  padTop?: boolean
}

export function Screen({ title, back = false, action, children = null, padTop = true }: Props) {
  const nav = useNavigate()
  return (
    <div className="flex min-h-full flex-col bg-bg-base">
      {(title || back || action) && (
        <header
          className={`flex items-center justify-between px-4 py-3 ${padTop ? 'pt-safe' : ''} sticky top-0 z-30 backdrop-blur-md bg-bg-base/85 border-b border-divider-subtle`}
        >
          <div className="flex items-center gap-2">
            {back && (
              <button
                type="button"
                onClick={() => (typeof back === 'function' ? back() : nav(-1))}
                className="inline-flex h-9 w-9 items-center justify-center rounded-full text-text-secondary hover:bg-white/5"
                aria-label="Back"
              >
                <ChevronLeftIcon />
              </button>
            )}
            {title && <h1 className="text-title font-display font-semibold text-text-primary">{title}</h1>}
          </div>
          <div>{action}</div>
        </header>
      )}
      <div className="flex-1">{children}</div>
    </div>
  )
}
